import { Component, Input, OnInit } from "@angular/core";
import { Wiring } from "../../../../../codegen/out/types";

@Component({
  selector: "app-tr-wiring-diagram",
  templateUrl: "./tr-wiring-diagram.component.html",
  styleUrls: ["./tr-wiring-diagram.component.scss"],
  standalone: false,
})
export class TrWiringDiagramComponent implements OnInit {
  @Input() wiring: Wiring;

  terminals = {};

  externalPowerSupplyNeeded = false;

  ngOnInit(): void {
    for (const terminal of this.wiring.terminals) {
      this.terminals[terminal.device] = terminal;
    }

    if (this.wiring.externalPowerSupplyNeeded) {
      this.externalPowerSupplyNeeded = true;
    }
  }
}
